// extracted by mini-css-extract-plugin
module.exports = {"priceItem":"NXAYoI","campaignPrice":"_2kMJhV","strikethrough":"yi9aJi"};